import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  adminProfile: null,
  isAuthenticated: false,
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAdminProfile(state, action) {
      state.adminProfile = action.payload;
      state.isAuthenticated = true;
      state.error = null;
    },
    clearAdminProfile(state) {
      state.adminProfile = null;
      state.isAuthenticated = false;
      state.error = null;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const { setAdminProfile, clearAdminProfile, setLoading, setError } =
  authSlice.actions;

export default authSlice.reducer;
